export default __webpack_public_path__ + "static/media/AuthBack.9a759b38.svg";